import { useSignIn } from '@clerk/react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { Apple } from 'lucide-react'

type AppleSignInButtonProps = {
  className?: string
}

export function AppleSignInButton({ className }: AppleSignInButtonProps) {
  const { signIn, fetchStatus } = useSignIn()

  const handleAppleSignIn = async () => {
    try {
      if (!signIn) {
        return
      }

      await signIn.sso({
        strategy: 'oauth_apple',
        redirectUrl: '/',
        redirectCallbackUrl: '/sso-callback',
      })
    } catch (error) {
      console.error('Apple sign-in error:', error)
    }
  }

  return (
    <Button
      type="button"
      onClick={handleAppleSignIn}
      variant="outline"
      className={cn("w-full bg-black hover:bg-black/90 text-white border-black flex items-center justify-center gap-3 disabled:opacity-50", className)}
      disabled={!signIn || fetchStatus === 'fetching'}
    >
      <Apple className="h-5 w-5" />
      Sign in with Apple
    </Button>
  )
}